module.exports = __webpack_public_path__ + "img/close-icon.981bbd0a.svg";